export type PreviewKind = 'image' | 'pdf' | 'spreadsheet' | 'text' | 'other';

export function guessPreviewKind(fileName: string): PreviewKind {
  const lower = fileName.toLowerCase();
  if (/\.(png|jpe?g|gif|webp|bmp|svg)$/.test(lower)) return 'image';
  if (lower.endsWith('.pdf')) return 'pdf';
  if (/\.(xlsx?|xlsm|csv)$/.test(lower)) return 'spreadsheet';
  if (/\.(txt|log|md)$/.test(lower)) return 'text';
  return 'other';
}
